// NGRX
import { Action } from '@ngrx/store';

// OLCI
import { label } from '../util';
import {ICreditCardBinPayload} from '../models/credit-card-bin.payload';
import { ITravelQuestionnairePayload } from '../models/travel-questionnaire.payload';
import { IGovernanceContentParams, IGovernanceContentPayload } from '../models/governance-content.payload';
import { IGranteeToPaymentAccountPayload } from '../models/action-payloads/grantee-to-payment-account-payload';
import { ISailingInformationPayload, ISailingInformationStore } from '../models/action-payloads/sailing-info-payload';
import { ICreateUpdateOnboardPaymentResponse } from '../models/action-payloads/create-update-onboard-payment-payload';
import  {IHealthCenterProtocolsParams, IHealthCenterProtocolsPayload} from '../models/healthyCenter-protocols.payload';
import {
  BoardingPassResponse,
  PersonalDetailContentResponse,
  CountryPayload
} from '../models';
import { SelectedCard } from '../models/guest-oexpenses';
import { HttpErrorResponse } from '@angular/common/http';
/**
 * For each action type in an action group, we make a simple
 * enum object for all of our action types.
 *
 * The 'label' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * actions in the application are unique.
 */

/*
LEGEND:
    LOAD: request server http.get or local mock
    LOAD_SUCCESS: return and update store
    UPDATE: gets user input info and updates store
    POST: send http.post to server
    POST_SUCCESS: return and update store
*/

export const OlciActionTypes = {
	// APP level actions
	CHANGE_LANGUAGE: label('[OLC]Change Language'),
	CHANGE_LANGUAGE_ERROR: label('[OLC]Change Language Error'),
	CHANGE_LANGUAGE_SUCCESS: label('[OLC]Change Language Success'),
	CLEAR_SESSION_STORAGE: label('[OLC] Clear session storage'),
	LOAD_CONTENT_ACTION: label('[OLC] Load Content Action'),
	LOAD_CONTENT_SUCCESS_ACTION: label('[OLC] Load Content Action Success'),
	LOAD_STATE: label('[OLC] Load State'),
	LOAD_STATE_SUCCESS: label('[OLC] Load State Success'),
	LOAD_STATE_FAIL: label('[OLC] Load State Fail'),
	POST_STATE: label('[OLC] Post State'),
	POST_STATE_SUCCESS: label('[OLC] Post State Success'),

	//Travel Questionnaire
	LOAD_TRAVEL_QUESTIONNAIRE: label('[OLC] Load travel questionnaire'),
	LOAD_TRAVEL_QUESTIONNAIRE_SUCCESS: label('[OLC] Load travel questionnaire success'),
	CREATE_UPDATE_TRAVEL_QUESTIONNAIRE_SUCCESS: label('[OLC] Create update travel questionnaire success'),

	// SESSION TIMEOUT
	CLEAR_STATE_ONLY: label('[OLC] Clear State Only'),
	CLEAR_SESSION_ONLY: label('[OLC] Clear Session Only'),
	SESSION_START: label('[OLC] Session Start'),
	SESSION_TIMESTAMP_RENEWED: label('[OLC] Session Timestamp Renewed'),
	SESSION_WARNING_MODAL: label('[OLC] Session Warning Modal'),

	SESSION_END: label('[OLC] Session End'),
	SESSION_END_ONLY: label('[OLC] Session End Only'),
	SESSION_END_FAIL: label('[OLC] Session End Fail'),
	SESSION_END_WARNING_MODAL: label('[OLC] Session End Warning Modal'),
	SESSION_TIMEOUT: label('[OLC] Session Timeout'),
	START_SESSION: label('[OLC] Start Session'),
	STOP_SESSION: label('[OLC] Stop Session'),

	// SET SAIL PASS
	GET_SET_SAIL_PASS: label('[OLC] Load Pass'),
	GET_SET_SAIL_PASS_SUCCESS: label('[OLC] Load Pass Success'),
	SET_SET_SAIL_PASS_ERROR: label('[OLC] SetSailPass Error'),
	RESET_SET_SAIL_PASS_ERROR: label('[OLC] ResetSailPass Error'),

	PDETAIL_CONTENT_LOAD: label('[OLC] Load Pdetail Content'),
	PDETAIL_CONTENT_LOAD_SUCCESS: label('[OLC]    Load Pdetail Content Success'),
	SESSION_VARS_SET: label('[OLC] Set Session Var'),
	UPDATE_SCREENSIZE: label('[OLC] Update Screen Size'),
	UPDATE_TITLE_BAR: label('[OLC] Updae Title bar '),
	LOAD_FAIL: label('[OLC] Load Fail'),
	NAVIGATE_TO_ERROR: label('[OLC] Navigate to error'),
	UPDATE_CHECKIN_TOKEN: label('[OLC] Update Checkin Token'),

  // SERVER ERRORS
  SET_RESPONSE_ERROR: label('[OLCI] Set Response Error'),
  SET_RESPONSE_ERROR_CLEAR: label('[OLCI] Set Response Error Clear'),

	LOAD_CRUISE_CONTRACT: label('[OLC] Load Cruise Contract'),
	LOAD_CRUISE_CONTRACT_SUCCESS: label('[OLC] Load Cruise Contract Success'),
	SAVE_AUTHORIZATION_CONSENTS_SUCCESS: label('[OLC] Save Biometrics Authorizations Success'),
	DELETE_BIOMETRICS_AUTHORIZATIONS_SUCCESS: label('[OLC] Delete Biometrics Authorizations Success'),
	LOAD_CRUISE_CONTRACT_USER_DETAILS_SUCCESS: label('[OLC] Load Cruise Contract User Details Success'),
	LOAD_CRUISE_CONTRACT_USER_DETAILS_FAIL: label('[OLC] Load Cruise Contract User Details Fail'),
	UPDATE_CRUISE_CONTRACT_DETAILS: label('[OLC] Update Cruise Contract Details'),
	SEND_CTC_EMAIL: label('[OLC] Send CTC Email'),

	// ARRIVAL TIME APPOINTMENTS
	LOAD_ARRIVAL_APPOINTMENT_AND_INVENTORY_SUCCESS: label('[OLC] Load Arrival Time Inventory Success'),
	POST_SET_UPDATE_ARRIVAL_TIMES_FAILURE: label('[OLC] Post Save Update Arrival Times Success'),
	UPDATE_ARRIVALTIMES_SELECTED_VM: label('[OLC] Update Arrival Times Selected ViewModel'),

	STORE_VDS_INFO: label('[OLC] Store Vds Info'),
	POST_SAILING_INFORMATION: label('[OLC] Post Sailing Information'),
	POST_SAILING_INFORMATION_SUCCESS: label('[OLC] Post Sailing Information Success'),
	POST_SAILING_INFORMATION_FAILURE: label('[OLC] Post Sailing Information Fail'),
	UPDATE_LOGGED_IN_GUEST_INFO: label('[OLC] Update Logged In Guest Id Info'),
	GET_RETRIVALRESP_SESSION: label('[OLC] Get retrival from server session'),
	POST_RETRIEVE_RESERVATION_FROM_LSTORAGE: label('[OLC] Post Retrieve Reservation From Local Storage'),

	// Onboard EXpense Account
	LOAD_GUESTS_ONBOARD_EXPENSES: label('[OLC] Load Guests Onboard Expenses'),
	LOAD_GUESTS_ONBOARD_EXPENSES_SUCCESS: label('[OLC] Load Guests Onboard Expenses Success'),
	SET_DISPLAY_CC_FORM: label('[OLC] Set Display CC Form'),
	SET_DISPLAY_CC_LIST: label('[OLC] Set Display CC List'),
	RESET_DISPLAY_CC_FORM: label('[OLC] Reset Display CC Form'),
	RESET_DISPLAY_CC_LIST: label('[OLC] Reset Display CC List'),
	RESET_GUESTS_ONBOARD_EXPENSES_ERROR: label('[OLC] Reset Guests Onboard Expenses Error'),
	RESET_GUESTS_ONBOARD_EXPENSES: label('[OLC] Reset Guests Onboard Expenses'),
	PAYMENT_ACCOUNT_TO_GRANTEE_SUCCESS: label('[OLC] payment to grantee success'),
	REMOVE_GRANTEES_SUCCESS: label('[OLC] remove grantees success'),
	REMOVE_GRANTEES_AND_UPDATE_TO_CASH_OR_NONE: label('[OLC] remove grantees and update to cash or none'),
	GRANTEE_TO_PAYMENT_ACCOUNT_SUCCESS: label('[OLC] Grantee to payment account success'),
	LOAD_PAYMENT: label('[OLC] Load Payment'),
	LOAD_PAYMENT_SUCCESS: label('[OLC] Load Payment Success'),
	SELECT_PAYMENT: label('[OLC] Select Payment'),
	LOAD_PAYMENT_INFO: label('[OLC] Load payment info'),
	LOAD_PAYMENT_INFO_SUCCESS: label('[OLC] Load payment info Success'),
	UPDATE_ONBOARD_EXPENSE: label('[OLC] Update Onboard Expense'),
	UPDATE_GUEST_CONSENT: label('[OLC] Update Guest Consent'),
	POST_ONBOARD_EXPENSE: label('[OLC] Post Onboard Expense'),
	DELETE_ONBOARD_EXPENSE: label('[OLC] Delete Onboard Expense'),
	UPDATE_GUEST_PAYMENT_TYPE_SUCCESS: label('[OLC] Update guest payment type success'),
	POST_ONBOARD_EXPENSE_SUCCESS: label('[OLC] Post Onboard Expense SUCCESS'),
	POST_ONBOARD_EXPENSE_SELECTED_CC: label('[OLC] Post Onboard Expenses Selected CC'),

	// CREDIT CARD COUNTRY
	CLEAR_CREDIT_CARD_COUNTRY: label('[OLCI] Clear Credit Card Country'),
	LOAD_CREDIT_CARD_COUNTRY: label('[OLCI] Load Credit Card Country'),
	LOAD_CREDIT_CARD_COUNTRY_SUCCESS: label('[OLCI] Load Credit Card Country Success'),
	LOAD_CREDIT_CARD_COUNTRY_FAILURE: label('[OLCI] Load Credit Card Country Error'),

	// MODALS
	FETCH_GOVERNANCE_CONTENT: label('[OLC] Fetch Governance Content'),
	FETCH_GOVERNANCE_CONTENT_SUCCESS: label('[OLC] Fetch Governance Content Success'),
	FETCH_GOVERNANCE_CONTENT_FAILURE: label('[OLC] Fetch Governance Content Error'),

	FETCH_HEALTH_CENTER_PROTOCOLS: label('[OLC] Fetch Health and Center protocols'),
	FETCH_HEALTH_CENTER_PROTOCOLS_SUCCESS: label('[OLC] Fetch Health and Center protocols Success'),
	FETCH_HEALTH_CENTER_PROTOCOLS_FAILURE: label('[OLC] Fetch Health and Center protocols Error'),

	//Get countries
	GET_COUNTRIES: label('[OLC] Get countries'),
	GET_COUNTRIES_SUCCESS: label('[OLC] Get countries Success'),
	GET_COUNTRIES_FAILURE: label('[OLC] Get countries Error'),

	POST_SEARCH_GUESTS: label('[OLC] Post Search Guests'),
	POST_SEARCH_GUESTS_SUCCESS: label('[OLC] Post Search Guests Success'),
	POST_SEARCH_GUESTS_FAILURE: label('[OLC] Post Search Guests Failure'),
	POST_SEARCH_MINORS: label('[OLC] Post Search Minors'),
	POST_SEARCH_MINORS_SUCCESS: label('[OLC] Post Search Minors Success'),
	POST_SEARCH_GUESTS_FOR_ASSOCIATIONS: label('[OLC] Post Search Guest For Associations'),
	POST_SEARCH_GUESTS_FOR_ASSOCIATIONS_SUCCESS: label('[OLC] Post Search Guest For Associations Success'),
	POST_SEARCH_MINORS_FAILURE: label('[OLC] Post Search Minors Failure'),
	POST_ADD_MINORS_TO_RESERVATION: label('[OLC] Post Add Minors To Reservation'),
	POST_ADD_MINORS_TO_RESERVATION_CTC: label('[OLC] Post Add Minors To Reservation CTC'),
	POST_ADD_MINORS_TO_RESERVATION_SUCCESS: label('[OLC] Post Add Minors To Reservation Success'),
	POST_ADD_MINORS_TO_RESERVATION_FAILURE: label('[OLC] Post Add Minors To Reservation Failure'),
	UPDATE_MINORS_TO_ADD_VM: label('[OLC] Update Minors to Add ViewModel'),
	UPDATE_GUESTS_TO_ADD_VM: label('[OLC] Update Guests to Add ViewModel'),
	RESET_GUESTS_SELECTED_FOR_CHECKIN_SUCCESS: label('[OLC] Reset Guests Selected For Checkin Process Success'),
	UPDATE_NO_GUESTS_TO_ADD_VM: label('[OLC] Update No Guests to Add ViewModel'),
	OPEN_MODAL: label('[Layout] Open modal'),
	CLOSE_MODAL: label('[Layout] Close modal'),
	SHOW_LOADER: label('[Layout] Show loader'),
	HIDE_LOADER: label('[Layout] Hide loader')
};

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in our reducer functions.
 */

// APP level actions

export class ChangeLanguageAction implements Action {
	type = OlciActionTypes.CHANGE_LANGUAGE;
	constructor(public payload: any) { }
}
export class ChangeLanguageErrorAction implements Action {
	type = OlciActionTypes.CHANGE_LANGUAGE_ERROR;
	constructor(public payload: any) { }
}
export class ChangeLanguageSuccessAction implements Action {
	type = OlciActionTypes.CHANGE_LANGUAGE_SUCCESS;
}

export class LoadStateAction implements Action {
	type = OlciActionTypes.LOAD_STATE;
}

export class PostStateAction implements Action {
	type = OlciActionTypes.POST_STATE;
}

export class PostStateSuccessAction implements Action {
	type = OlciActionTypes.POST_STATE_SUCCESS;
	constructor(public payload: any) { }
}

export class LoadStateSuccessAction implements Action {
	type = OlciActionTypes.LOAD_STATE_SUCCESS;
	constructor(public payload: any) { }
}

export class LoadStateFailAction implements Action {
	type = OlciActionTypes.LOAD_STATE_FAIL;
	constructor(public payload: any) { }
}

// STATIC CONTENT ACTIONS
export class LoadPdetailContentSuccessAction implements Action {
	type = OlciActionTypes.PDETAIL_CONTENT_LOAD_SUCCESS;
	constructor(public payload: PersonalDetailContentResponse) { }
}

export class LoadPdetailContentAction implements Action {
	type = OlciActionTypes.PDETAIL_CONTENT_LOAD;
}

export class SessionVarSet implements Action {
	type = OlciActionTypes.SESSION_VARS_SET;
	constructor(public payload: any) { }
}

export class UpdateScreenSizeAtion implements Action {
	type = OlciActionTypes.UPDATE_SCREENSIZE;
	constructor(public payload: any) { }
}

export class UpdateTitleBarAction implements Action {
	type = OlciActionTypes.UPDATE_TITLE_BAR;
	constructor(public payload: any) { }
}

export class SessionStartAction implements Action {
	type = OlciActionTypes.SESSION_START;
	constructor(public payload: Object) { }
}

export class SessionTimestampRenewedAction implements Action {
	type = OlciActionTypes.SESSION_TIMESTAMP_RENEWED;
}

export class SessionWarningModalAction implements Action {
	type = OlciActionTypes.SESSION_WARNING_MODAL;
}

export class SessionEndOnlyAction implements Action {
	type = OlciActionTypes.SESSION_END_ONLY;
}

export class ClearStateOnlyAction implements Action {
	type = OlciActionTypes.CLEAR_STATE_ONLY;
}

export class ClearSessionOnlyAction implements Action {
	type = OlciActionTypes.CLEAR_SESSION_ONLY;
}

export class SessionEndFailAction implements Action {
	type = OlciActionTypes.SESSION_END_FAIL;
}

export class SessionEndWarningModalAction implements Action {
	type = OlciActionTypes.SESSION_END_WARNING_MODAL;
}

export class SessionTimeoutAction implements Action {
	type = OlciActionTypes.SESSION_TIMEOUT;
}

export class StartSessionAction implements Action {
	type = OlciActionTypes.START_SESSION;
	constructor(public payload: Object) { }
}

export class StopSessionAction implements Action {
	type = OlciActionTypes.STOP_SESSION;
	constructor(public payload: Object) { }
}

// Cruise Ticket Contract Actions
export class LoadCruiseContractAction implements Action {
	type = OlciActionTypes.LOAD_CRUISE_CONTRACT;
	constructor(public payload: Object, public oldPayload: Object) { }
}

export class LoadCruiseContractSuccessAction implements Action {
	type = OlciActionTypes.LOAD_CRUISE_CONTRACT_SUCCESS;
	constructor(public payload: any) { }
}

export class UpdateCruiseContractDetailsAction implements Action {
	type = OlciActionTypes.UPDATE_CRUISE_CONTRACT_DETAILS;
	constructor(public payload: any) { }
}

export class SaveAuthorizationConsentsSuccessAction implements Action {
	type = OlciActionTypes.SAVE_AUTHORIZATION_CONSENTS_SUCCESS;
	constructor(public payload: any) { }
}

export class DeleteBiometricsAuthorizationsSuccessAction implements Action {
	type = OlciActionTypes.DELETE_BIOMETRICS_AUTHORIZATIONS_SUCCESS;
	constructor(public payload: any) { }
}

export class SendCTCEmailAction implements Action {
	type = OlciActionTypes.SEND_CTC_EMAIL;
	constructor(public payload: any) { }
}

// Onboard EXpense Account
export class LoadGuestsOnboardExpenses {
	type = OlciActionTypes.LOAD_GUESTS_ONBOARD_EXPENSES;
	payload = null;
}

export class LoadGuestsOnboardExpensesSuccess {
	type = OlciActionTypes.LOAD_GUESTS_ONBOARD_EXPENSES_SUCCESS;
	constructor(public payload: any) { }
}

export class SetDisplayCCForm {
	type = OlciActionTypes.SET_DISPLAY_CC_FORM;
	constructor(public payload: any) { }
}

export class SetDisplayCCList {
	type = OlciActionTypes.SET_DISPLAY_CC_LIST;
	constructor(public payload: any) { }
}

export class ResetDisplayCCForm {
	type = OlciActionTypes.RESET_DISPLAY_CC_FORM;
	constructor(public payload: any) { }
}

export class ResetDisplayCCList {
	type = OlciActionTypes.RESET_DISPLAY_CC_LIST;
	constructor(public payload: any) { }
}

export class ResetGuestsOnboardExpenses {
	type = OlciActionTypes.RESET_GUESTS_ONBOARD_EXPENSES;
}

export class ResetGuestsOnboardExpensesError {
	type = OlciActionTypes.RESET_GUESTS_ONBOARD_EXPENSES_ERROR;
}

export class LoadPaymentAction implements Action {
	type = OlciActionTypes.LOAD_PAYMENT;
	constructor(public payload: JSON) { }
}

export class LoadPaymentSuccessAction implements Action {
	type = OlciActionTypes.LOAD_PAYMENT_SUCCESS;
	constructor(public payload: JSON) { }
}

export class LoadOnboardExpenseAction implements Action {
	type = OlciActionTypes.LOAD_PAYMENT_INFO;
	constructor(public payload: JSON) { }
}

export class LoadOnboardExpenseSuccessAction implements Action {
	type = OlciActionTypes.LOAD_PAYMENT_INFO_SUCCESS;
	constructor(public payload: JSON) { }
}

export class UpdateOnboardExpenseAction implements Action {
	type = OlciActionTypes.UPDATE_ONBOARD_EXPENSE;
	constructor(public payload: JSON) { }
}

export class UpdateGuestConsentAction implements Action {
	type = OlciActionTypes.UPDATE_GUEST_CONSENT;
	constructor(public payload: any) { }
}

export class PaymentAccountToGranteeSuccessAction implements Action {
	type = OlciActionTypes.PAYMENT_ACCOUNT_TO_GRANTEE_SUCCESS;
	constructor(public payload: any) { }
}

export class RemoveGranteesSuccessAction implements Action {
	type = OlciActionTypes.REMOVE_GRANTEES_SUCCESS;
	constructor(public payload: IGranteeToPaymentAccountPayload) { }
}

export class RemoveGranteesAndUpdateToCashOrNone implements Action {
	type = OlciActionTypes.REMOVE_GRANTEES_AND_UPDATE_TO_CASH_OR_NONE;
	constructor(public payload: IGranteeToPaymentAccountPayload) { }
}

export class GranteeToPaymentAccountSuccessAction implements Action {
	type = OlciActionTypes.GRANTEE_TO_PAYMENT_ACCOUNT_SUCCESS;
	constructor(public payload: any) { }
}

export class PostOnboardExpenseAction implements Action {
	type = OlciActionTypes.POST_ONBOARD_EXPENSE;
	constructor(public payload: any) { }
}

export class PostOnboardExpenseSuccessAction implements Action {
	type = OlciActionTypes.POST_ONBOARD_EXPENSE_SUCCESS;
	constructor(public payload: ICreateUpdateOnboardPaymentResponse) { }
}

export class PostOnboardExpenseSelectedCCAction implements Action {
	type = OlciActionTypes.POST_ONBOARD_EXPENSE_SELECTED_CC;
	constructor(public payload: SelectedCard) { }
}

export class SelectPaymentAction implements Action {
	type = OlciActionTypes.SELECT_PAYMENT;
	constructor(public payload: JSON) { }
}

// Set Sail    page actions
export class GetSetSailpassAction implements Action {
	type = OlciActionTypes.GET_SET_SAIL_PASS;
	constructor(public payload: Object) { }
}

export class GetSetSailpassSuccessAction implements Action {
	type = OlciActionTypes.GET_SET_SAIL_PASS_SUCCESS;
	constructor(public payload: BoardingPassResponse) { }
}

export class SetSetSailpassErrorAction implements Action {
	type = OlciActionTypes.SET_SET_SAIL_PASS_ERROR;
	constructor(public payload: Object) { }
}

export class ResetSetSailpassErrorAction implements Action {
	type = OlciActionTypes.RESET_SET_SAIL_PASS_ERROR;
}

export class LoadFailAction implements Action {
	type = OlciActionTypes.LOAD_FAIL;
	constructor(public payload: Object) { }
}

export class NavigateToError implements Action {
	type = OlciActionTypes.NAVIGATE_TO_ERROR;
}

export class ClearSessionStorageAction implements Action {
	type = OlciActionTypes.CLEAR_SESSION_STORAGE;
}

export class SetResponseErrorAction implements Action {
	type = OlciActionTypes.SET_RESPONSE_ERROR;
	constructor(public payload: HttpErrorResponse) { }
}

export class SetResponseErrorClearAction implements Action {
	type = OlciActionTypes.SET_RESPONSE_ERROR_CLEAR;
}

export class UpdateCheckinToken implements Action {
	type = OlciActionTypes.UPDATE_CHECKIN_TOKEN;
	constructor(public payload: string) { }
}

// Arrival Time Actions

export class LoadArrivalAppointmentAndInventorySuccessAction implements Action {
	type = OlciActionTypes.LOAD_ARRIVAL_APPOINTMENT_AND_INVENTORY_SUCCESS;
	constructor(public payload: { status: any; errors: any; payload: any; firstAdultId: any }) { }
}

export class PostSaveOrUpdateArrivalTimesFailureAction implements Action {
	type = OlciActionTypes.POST_SET_UPDATE_ARRIVAL_TIMES_FAILURE;
	constructor(public payload: { status: any; errors: any; payload: any; firstAdultId: any }) { }
}

export class UpdateArrivalTimesSelectedVM implements Action {
	type = OlciActionTypes.UPDATE_ARRIVALTIMES_SELECTED_VM;
	constructor(public payload: any) { }
}

// Retrieve Reservation
export class StoreVdsInfoAction implements Action {
	type = OlciActionTypes.STORE_VDS_INFO;
	constructor(public payload: any) { }
}

export class PostSailingInformationAction implements Action {
	type = OlciActionTypes.POST_SAILING_INFORMATION;
	constructor(public payload: ISailingInformationPayload) { }
}

export class PostSailingInformationSuccessAction implements Action {
	type = OlciActionTypes.POST_SAILING_INFORMATION_SUCCESS;
	constructor(public payload: ISailingInformationStore) { }
}

export class PostSailingInformationFailureAction implements Action {
	type = OlciActionTypes.POST_SAILING_INFORMATION_FAILURE;
	constructor(public payload:any) {}
}

export class UpdateLoggedInGuestInfoAction implements Action {
	type = OlciActionTypes.UPDATE_LOGGED_IN_GUEST_INFO;
	constructor(public payload: any) { }
}

export class GetRetrivalResSessionAction implements Action {
	type = OlciActionTypes.GET_RETRIVALRESP_SESSION;
}

export class LoadContentAction implements Action {
	type = OlciActionTypes.LOAD_CONTENT_ACTION;
	payload = null;
}

export class LoadContentSuccessAction implements Action {
	type = OlciActionTypes.LOAD_CONTENT_SUCCESS_ACTION;
	constructor(public payload: any) { }
}

export class LoadTravelQuestionnaireAction implements Action {
	type = OlciActionTypes.LOAD_TRAVEL_QUESTIONNAIRE;
	constructor(public payload: ITravelQuestionnairePayload) { }
}

export class LoadTravelQuestionnaireActionSuccess implements Action {
	type = OlciActionTypes.LOAD_TRAVEL_QUESTIONNAIRE_SUCCESS;
	constructor(public payload: any) { }
}

export class CreateUpdateTravelQuestionnaireActionSuccess implements Action {
	type = OlciActionTypes.CREATE_UPDATE_TRAVEL_QUESTIONNAIRE_SUCCESS;
	constructor(public payload: any) { }
}

/*******Layout */
export class OpenModalAction implements Action {
	type = OlciActionTypes.OPEN_MODAL;
	constructor(public payload: any) { }
}

export class CloseModalAction implements Action {
	type = OlciActionTypes.CLOSE_MODAL;
}

/*******Layout */
export class ShowLoaderAction implements Action {
	type = OlciActionTypes.SHOW_LOADER;
	constructor(public payload: string) { }
}

export class HideLoaderAction implements Action {
	type = OlciActionTypes.HIDE_LOADER;
}

export class ClearCreditCardCountry implements Action {
  type = OlciActionTypes.CLEAR_CREDIT_CARD_COUNTRY;
}

export class LoadCreditCardCountry implements Action {
  type = OlciActionTypes.LOAD_CREDIT_CARD_COUNTRY;
  constructor(public payload: ICreditCardBinPayload) {}
}

export class LoadCreditCardCountrySuccess implements Action {
  type = OlciActionTypes.LOAD_CREDIT_CARD_COUNTRY_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadCreditCardCountryFailure implements Action {
  type = OlciActionTypes.LOAD_CREDIT_CARD_COUNTRY_FAILURE;
  constructor(public payload: any) {}
}

export class FetchGovernanceContent implements Action {
	type = OlciActionTypes.FETCH_GOVERNANCE_CONTENT;
	constructor(public payload: IGovernanceContentParams) { }
}

export class FetchGovernanceContentSuccess implements Action {
	type = OlciActionTypes.FETCH_GOVERNANCE_CONTENT_SUCCESS;
	constructor(public payload: IGovernanceContentPayload) { }
}

export class FetchGovernanceContentFailure implements Action {
	type = OlciActionTypes.FETCH_GOVERNANCE_CONTENT_FAILURE;
	constructor(public payload: any) { }
}

export class FetchHealthCenterProtocols implements Action {
	type = OlciActionTypes.FETCH_HEALTH_CENTER_PROTOCOLS;
	constructor(public payload: IHealthCenterProtocolsParams) { }
}

export class FetchHealthCenterProtocolsSuccess implements Action {
	type = OlciActionTypes.FETCH_HEALTH_CENTER_PROTOCOLS_SUCCESS;
	constructor(public payload: IHealthCenterProtocolsPayload) { }
}

export class FetchHealthCenterProtocolsFailure implements Action {
	type = OlciActionTypes.FETCH_HEALTH_CENTER_PROTOCOLS_FAILURE;
	constructor(public payload: any) { }
}

export class GetCountries implements Action {
	type = OlciActionTypes.GET_COUNTRIES;
}

export class GetCountriesSuccess implements Action {
	type = OlciActionTypes.GET_COUNTRIES_SUCCESS;
	constructor(public payload: CountryPayload) { }
}

export class GetCountriesFailure implements Action {
	type = OlciActionTypes.GET_COUNTRIES_FAILURE;
	constructor(public payload: any) { }
}

/**
 * We export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type OlciActions =
	| LoadStateAction
	| PostStateAction
	| PostStateSuccessAction
	| LoadStateSuccessAction
	| LoadStateFailAction
	| LoadPdetailContentAction
	| LoadPdetailContentSuccessAction
	| UpdateTitleBarAction
	| UpdateScreenSizeAtion
	| SessionVarSet
	| SessionStartAction
	| SessionTimestampRenewedAction
	| SessionWarningModalAction
	| SessionEndOnlyAction
	| SessionEndFailAction
	| SessionEndWarningModalAction
	| SessionTimeoutAction
	| ClearStateOnlyAction
	| ClearSessionOnlyAction
	| StartSessionAction
	| StopSessionAction
	| GetSetSailpassAction
	| GetSetSailpassSuccessAction
	| SetSetSailpassErrorAction
	| ResetSetSailpassErrorAction
	| LoadCruiseContractAction
	| LoadCruiseContractSuccessAction
	| UpdateCruiseContractDetailsAction
	| LoadFailAction
  | SetResponseErrorAction
  | SetResponseErrorClearAction
	| LoadArrivalAppointmentAndInventorySuccessAction
	| PostSaveOrUpdateArrivalTimesFailureAction
	| UpdateArrivalTimesSelectedVM
	| LoadGuestsOnboardExpenses
	| LoadGuestsOnboardExpensesSuccess
	| ResetGuestsOnboardExpenses
	| LoadPaymentAction
	| LoadPaymentSuccessAction
	| LoadOnboardExpenseAction
	| LoadOnboardExpenseSuccessAction
	| UpdateOnboardExpenseAction
	| UpdateGuestConsentAction
	| PostOnboardExpenseAction
	| PostOnboardExpenseSuccessAction
	| SelectPaymentAction
	| PostSailingInformationAction
	| PostSailingInformationSuccessAction
	| PostSailingInformationFailureAction
	| UpdateLoggedInGuestInfoAction
	| GetRetrivalResSessionAction
	| LoadContentAction
	| CloseModalAction
	| OpenModalAction
	| ChangeLanguageAction
	| ShowLoaderAction
	| HideLoaderAction
	| LoadTravelQuestionnaireAction
	| LoadTravelQuestionnaireActionSuccess
	| CreateUpdateTravelQuestionnaireActionSuccess
	| FetchGovernanceContent
	| FetchHealthCenterProtocols
	| GetCountries
	| GetCountriesSuccess
	| GetCountriesFailure
